'use client';

import { forwardRef } from 'react';
import type { ColorPickerProps as MantineColorPickerProps } from '@mantine/core';
import { ColorPicker as MantineColorPicker } from '@mantine/core';

import type { LockedProps } from '../types';

export type ColorPickerProps = Omit<MantineColorPickerProps, LockedProps>;

/**
 * Wraps Mantine `ColorPicker` with a restricted public API. Defaults to the
 * `hex` format (no alpha slider); callers can still override `format`.
 */
export const ColorPicker = forwardRef<HTMLDivElement, ColorPickerProps>((props, ref) => {
  return <MantineColorPicker format="hex" {...props} ref={ref} />;
});

ColorPicker.displayName = 'ColorPicker';
